import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrls, apiHostUrl } from '../../shared/utils/globalConfig';
import { addHeaders } from '../../shared/utils/globalUtils';

export const billSummaryApi = createApi({
    reducerPath: 'billSummary',
    baseQuery: fetchBaseQuery({
        baseUrl: apiHostUrl,
        prepareHeaders: (headers) => {
            return addHeaders(headers);
        }
    }),
    endpoints: (builder) => ({       
        getBillSummaryByName: builder.query({           
            query: () => ({
                url: apiUrls?.itpNsaNextBillSummaryUrl,
                method: 'POST',
                body: {
                    "dashboard": false
                }
            })
        }),
    }),

})

export const { useLazyGetBillSummaryByNameQuery } = billSummaryApi;